import React from "react";
import withSizePositionAngle from "components/withSizePositionAngle";


const _Zon = () => {
    return (
        <g transform="translate(-587.660226 -376.801744)">
          <circle r="61.845776" cy="438.64752" cx="649.50781" fill="#ffb700" fillOpacity="1" stroke="none" strokeWidth="8.12107" strokeLinecap="round" strokeLinejoin="round" strokeDashoffset="37.7986"/>
        </g>
    );
}

const Zon = withSizePositionAngle(_Zon, 123.693360, 123.693360);

export default Zon;
